import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="5.27mm"
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 79968 103185"
    {...props}
  >
    <path
      d="M39984 2580c20276 0 37404 8268 37404 18057 0 2484-1063 4646-2528 6449H5108c-1465-1803-2528-3965-2528-6449 0-9789 17128-18057 37404-18057zm30655 28310c-10713 7414-17109 19670-17109 32785v12430c0 672-173 1305-475 1855-8 14-15 26-23 38-663 1179-1927 1976-3371 1976H30307c-2132 0-3869-1734-3869-3869V63675c0-13115-6396-25371-17109-32785-531-369-1080-775-1624-1224h64558c-545 449-1093 855-1624 1224zM52882 85127l-25796 6v-3443c948 550 2050 864 3221 864h19354c1171 0 2273-314 3221-864v3437zm0 5712-25796 4v-3130l25796-6v3132zm0 3130c0 1422-1158 2580-2578 2580l-20637 4h-1c-689 0-1337-268-1824-754-487-488-756-1136-756-1825v-551l25796-5v551zm-10318 6630-5158 6c-1027 0-1917-602-2332-1473l9819-2c-416 868-1304 1469-2329 1469zM7862 33011c10016 6934 15996 18396 15996 30664v12430c0 1009 234 1965 648 2816v15053c0 1379 536 2674 1512 3649 975 974 2270 1510 3648 1510h2699c508 2314 2575 4052 5042 4052l5158-7c2463 0 4530-1735 5038-4049h2701c2844 0 5158-2316 5158-5160V78921c414-851 648-1807 648-2816V63675c0-12268 5980-23730 15996-30664 5144-3559 7862-7839 7862-12374C79968 9065 62404 0 39984 0 17563 0 0 9065 0 20637c0 4535 2718 8815 7862 12374z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
